import { ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { Pill } from '~components';
import VectorImage from '~components/media/vectorImage';
import PillVariant from '~enums/pillVariant';
import { Dimens } from '~themes';

import isActivePath from '../isActivePath';
import menuRowSx from '../menuRowSx';
import { SideMenuPage } from '../types';
import { MenuLi } from './menuPrimitives';

interface Props {
	page: SideMenuPage;
	showLabel: boolean;
	/** Rows inside a dropdown get a small left inset. */
	nested?: boolean;
}

const PageRow = ({ page, showLabel, nested = false }: Props) => {
	const { typography } = useTheme();
	const { pathname } = useLocation();
	const selected = isActivePath(pathname, page.path);
	const iconSize = showLabel ? Dimens.fixed(20) : Dimens.fixed(24);

	return (
		<MenuLi block={!showLabel}>
			<ListItemButton
				component={Link}
				to={page.path}
				aria-current={selected ? 'page' : undefined}
				sx={menuRowSx({
					active: selected,
					nested,
					height: showLabel ? Dimens.fixed(36) : Dimens.fixed(44),
					width: showLabel ? 'auto' : Dimens.fixed(44),
				})}
			>
				{page.iconName && (
					<ListItemIcon
						sx={{
							width: iconSize,
							minWidth: iconSize,
							height: iconSize,
							minHeight: iconSize,
						}}
					>
						<VectorImage name={page.iconName} size={iconSize} />
					</ListItemIcon>
				)}
				<ListItemText
					primary={page.label}
					hidden={!showLabel}
					sx={{ ['& .MuiListItemText-primary']: { xs: typography.labelSm, xl: typography.label } }}
				/>
				{showLabel && page.badge != null && (
					<Pill label={String(page.badge)} size='md' variant={PillVariant.Green} />
				)}
			</ListItemButton>
		</MenuLi>
	);
};

export default PageRow;
